<button mat-icon-button class="navbar-toggle-button"
        (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
    <mat-icon class="secondary-text">menu</mat-icon>
</button>
